/**
 * dedupedFetch — in-flight request de-duplication shared by every hook
 * that fetches on mount (useFeaturedTestimonials, useEcosystemDataset,
 * Header's release-pulse check).
 *
 * Root cause this exists for (found + fixed Aug 2026): React 18
 * StrictMode intentionally double-invokes mount effects in development,
 * and — independent of that — some pages render two sibling components
 * that both need the exact same resource (e.g. a "spotlight" and a
 * "grid" testimonial surface for the same service). Either way, a
 * plain `fetch()` inside a `useEffect` with no de-dupe guard fires a
 * real, wasteful, byte-identical network request twice.
 *
 * This is a CONCURRENCY-WINDOW de-dupe only, not a cache: the map entry
 * for a URL is removed the instant that request settles (success or
 * failure), so a later, genuinely new request for the same URL always
 * hits the network fresh. No data is ever served stale, and nothing
 * outside the exact call sites that opt in is affected.
 */
const inFlightByUrl = new Map();

export function fetchJsonDeduped(url) {
  const existing = inFlightByUrl.get(url);
  if (existing) return existing;
  const promise = fetch(url)
    .then((res) => {
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      return res.json();
    })
    .finally(() => {
      inFlightByUrl.delete(url);
    });
  inFlightByUrl.set(url, promise);
  return promise;
}
